import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PurchasePlaceBackendServer extends BaseBackend {

  getPurchasePlaces(builder): Observable<any> {
    return this.get('/purchase-place', { params: builder });
  }

  getPurchasePlace(code): Observable<any> {
    return this.get(`/purchase-place/${ code }`);
  }

  getPurchasePlaceCodes(): Observable<any> {
    return this.get('/purchase-place/code');
  }

  savePurchasePlace(purchasePlace): Observable<any> {
    const { code } = purchasePlace;
    if (purchasePlace._id) {
      return this.patch(`/purchase-place/${ code }`, purchasePlace);
    }
    return this.post('/purchase-place', purchasePlace);
  }

  deletePurchasePlace(code): Observable<any> {
    return this.delete(`/purchase-place/${ code }`);
  }
}
